import { Component, OnInit, ViewChild } from '@angular/core';
import { SnackbarService } from '@services/snackbar/snackbar.service';

import moment from 'moment';
import { Router } from '@angular/router';
import { CodeSnippetService } from '@services/code-snippets/code-snippet.service';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-code-snippets',
    templateUrl: './code-snippets.component.html',
    styleUrls: ['./code-snippets.component.scss'],
    providers: [CodeSnippetService],
    standalone: false
})
export class CodeSnippetsComponent implements OnInit {

  @ViewChild(DataTableComponent) dataTable: DataTableComponent;

  public title = 'All Code Snippets';

  public subtitle: string;

  public pageActions: PageAction[];

  public columns = [
    { prop: 'title', name: 'Title' },
    { prop: 'name', name: 'Name' },
    { prop: 'type', name: 'Type' },
    {
      prop: 'updated', name: 'Last update', valueTransformer: function(date) {
        return moment(date).fromNow();
      }
    },
  ];

  public searchColumns = [{ prop: 'title', name: 'Title' }, { prop: 'name', name: 'Name' }];

  public params: any;

  constructor(
    public codeSnippetService: CodeSnippetService,
    public dialogService: DialogService,
    private router: Router,
    private snackbar: SnackbarService,
  ) {
  }

  ngOnInit() {
    this.createPageActions();
  }

  onDetail(event: DataTableEvent) {
    this.router.navigate(['code-snippets/', event.row._id]);
  }

  onEdit(event: DataTableEvent) {
    this.router.navigate(['code-snippets/', event.row._id, 'edit']);
  }

  onRemove(event: DataTableEvent) {
    this.dialogService
      .confirm('Delete this Snippet?')
      .then(res => {
        if (!res) {
          return;
        }
        return this.codeSnippetService.remove(event.row._id).then(() => {
          this.dataTable.refresh();
          this.snackbar.success('Snippet removed', 2000);
        }, error => {
          const message = (error.error.message ? error.error.message : error.message);
          console.error(error);
          return this.dialogService.confirm(message, error.name);
        });
      });
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'format_paint',
        title: 'Create new Snippet',
        callback: () => {
          this.router.navigate(['code-snippets/create/']);
        }
      })
    ];
  }
}
